import { render, staticRenderFns } from "./DecoratedFeatureValue.vue?vue&type=template&id=330ee98c"
import script from "./DecoratedFeatureValue.vue?vue&type=script&lang=js"
export * from "./DecoratedFeatureValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports